.file {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.name {
  overflow: hidden;
  color: var(--ink);
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.size {
  color: var(--muted);
  font-size: var(--t-min);
}

.none {
  color: var(--muted);
}

.link {
  color: var(--accent);
  font-weight: 600;
}
